/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { Component, ChangeDetectionStrategy, Input, TemplateRef } from '@angular/core';

@Component({
	selector: 'loading-blocker-spinner2',
	templateUrl: './loading-blocker-spinner.component.html',
	styleUrls: ['../loading-blocker.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadingBlockerSpinnerComponent {
	@Input() transparent: boolean = true;
	@Input() displayGlobally: boolean = false;
	@Input() customContent?: TemplateRef<any>;

	constructor() {}
}
